import { render, staticRenderFns } from "./ModalSection.vue?vue&type=template&id=72eddb32&scoped=true&"
import script from "./ModalSection.vue?vue&type=script&lang=js&"
export * from "./ModalSection.vue?vue&type=script&lang=js&"
import style0 from "./ModalSection.vue?vue&type=style&index=0&id=72eddb32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eddb32",
  null
  
)

export default component.exports